import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MarketingService {
    /**
     * Marketing Summary
     * API to Trigger the Slack message notification for Marketing Summary
     * @returns any Successful Response
     * @throws ApiError
     */
    static marketingSummaryMarketingApiUeScrapingSummaryPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/marketing/api/ue_scraping_summary',
        });
    }
    /**
     * Ingestion Gap Summary
     * API to Trigger the Slack message notification for Ingestion Gap Summary
     * @returns any Successful Response
     * @throws ApiError
     */
    static ingestionGapSummaryMarketingApiIngestionGapSummaryPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/marketing/api/ingestion_gap_summary',
        });
    }
    /**
     * Data Mismatch Summary
     * API to Trigger the Slack message notification for Data Mismatch Summary
     * @returns any Successful Response
     * @throws ApiError
     */
    static dataMismatchSummaryMarketingApiDataMismatchSummaryPost() {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/marketing/api/data_mismatch_summary',
        });
    }
    /**
     * Trigger Marketing Alert
     * Sends marketing alerts for chains to slack
     * @param alert
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerMarketingAlertMarketingAlertPost(alert, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/marketing/alert',
            query: {
                'alert': alert,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Coa Incremental Run
     * Triggers chainwise incremental order attribution
     *
     * Creates cloud tasks for each chain pointing to the background-jobs/coa_runner/attribute_orders
     * route in background job service.
     *
     * List of chains can be passed optionally. If no chains are passed then all chains having the TruROI
     * module enabled will be selected.
     * @param campaignType
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static triggerCoaIncrementalRunMarketingCoaTriggerIncrementalRunPost(campaignType, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/marketing/coa/trigger_incremental_run',
            query: {
                'campaign_type': campaignType,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
